import $ from 'jquery';

const threshold = 50;
const scrolledClass = 'windowIsScrolled';

$(() => {
  $(window).on('scroll.trackScrolled', function () {
    $('html').toggleClass(scrolledClass, $(window).scrollTop() > threshold);
  }).scroll();
});
